import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/services';

@Component({
  selector: 'app-cancellation-policy',
  templateUrl: './cancellation-policy.component.html',
  styleUrls: ['./cancellation-policy.component.scss']
})
export class CancellationPolicyComponent implements OnInit {

  policy:any = "";

  constructor(public http: HttpService) { }

  ngOnInit(): void {
    this.policy = JSON.parse(localStorage.getItem('property_detail')!);
  }

}
